import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import dsBankApi from "service/TichHopBank/dsBankApi";
import { pushNotification } from "utils/notifications";
import { DanhSachBankConst } from "../../../../constants/danhSachTaiSanConst";
import { formatDayMonth, currentDate, convertDate } from "utils/formatDate";
import DateTimePicker from "components/GenericComponent/DateTimePicker";
import giaodichBankApi from "service/TichHopBank/lichSuGiaoDichBankApi";
import moment from "moment";

export const DongBoLichSu = (props) => {
  const dispatch = useDispatch();
  const [NgayGiaoDich, setNgayGiaoDich] = useState(convertDate(currentDate()));
  const [BankId, setBankId] = useState("");
  const [dataBank, setDataBank] = useState({});
  const [bDisable, setDisableButton] = useState(false);

  const currentForm = useForm();
  const { handleSubmit } = currentForm;

  useEffect(() => {
    dsBankApi
      .list({
        sSearch: "",
        sMaNganHang: "",
        iPageSize: -1,
        iPageIndex: -1,
        isKhoa: 0,
        isDangKyNhanPushBDSD: null,
      })
      .then((response) => {
        if (response.status == "200") {
          setDataBank(response.data);
          setBankId(response.data.List[0].Id);
        } else {
        }
      });
  }, []);
  const updateSelect = () => (e) => {
    setBankId(e.target.value);
  };
  const onChangeDate = (field) => (evt) => {
    setNgayGiaoDich(convertDate(formatDayMonth(evt)));
  };
  const dongbodulieu = () => {
    setDisableButton(true);
    let ngay = moment(NgayGiaoDich).format("YYYY-MM-DD");
    console.log(NgayGiaoDich);
    console.log(ngay);
    giaodichBankApi
      .dongBoDuLieuBank({
        BankId: BankId,
        NgayGiaoDich: ngay,
      })
      .then((response) => {
        setDisableButton(false);
        if (response.status === 200) {
          props.data.onSearch();
          props.onHide();
          pushNotification(
            "Thao tác thành công",
            "success",
            "TOP_CENTER",
            2000
          );
        } else {
          pushNotification(response.data, "error", "TOP_CENTER", 2000);
        }
      });
  };

  return (
    <Modal
      {...props}
      size="modal-dialog"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="fade modal-new modal fade text-left modal show"
      backdrop="static"
    >
      <Modal.Header>
        <h4 className="modal-title" id="myModalLabel16">
          <span className="btn-icon-right">
            <i className="fas fa-plus"></i>
          </span>{" "}
          Đồng bộ giao dịch từ ngân hàng.
        </h4>
        <button
          type="button"
          className="close-popup-new"
          data-dismiss="modal"
          aria-label="Close"
          onClick={props.onHide}
        >
          <i className="mdi mdi-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <div className="form-body">
          <div className="card collapse-icon accordion-icon-rotate">
            <div
              id="collapse196"
              aria-labelledby="headingCollapse96"
              className="card-collapse collapse show"
              aria-expanded="true"
            >
              <div className="card-content">
                <div className="form-group row text-left">
                  <label className="col-md-5 label-control">Tài khoản:</label>
                  <div className="col-md-7">
                    <select
                      class="form-control input-sm"
                      value={BankId}
                      onChange={updateSelect()}
                    >
                      {dataBank &&
                        typeof dataBank.List !== "undefined" &&
                        dataBank.List.map((item, idx) => (
                          <option key={"comboBank" + idx} value={item.Id}>
                            {item.MaNganHang + " - " + item.SoTaiKhoan}
                          </option>
                        ))}
                    </select>
                  </div>
                </div>
                <div className="form-group row text-left">
                  <label className="col-md-5 label-control">
                    Ngày giao dịch <span className="canh-bao-red">*</span>
                  </label>
                  <div className="col-md-7">
                    <DateTimePicker
                      value={NgayGiaoDich}
                      onChange={onChangeDate("NgayGiaoDich")}
                      placeholder="NgayGiaoDich"
                      name="NgayGiaoDich"
                      className="form-control input-sm"
                    ></DateTimePicker>
                  </div>
                </div>
                <div className="form-group row text-center">
                  <label
                    style={{ color: "#056569 !important" }}
                    className="col-md-12 label-control"
                  >
                    Bạn có thể đồng bộ dữ liệu giao dịch ngân hàng trong vòng 30
                    ngày gần đây.
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer className="modal-footer button-popup-new-size">
        <button
          className="btn btn-new-main btn-checknew"
          onClick={dongbodulieu}
          disabled={bDisable}
        >
          <span className="btn-icon-left">
            <i className="mdi mdi-check"></i>
          </span>
          Đồng bộ dữ liệu
        </button>
        &nbsp;
        <a
          className="btn btn-new-main btn-closenew"
          data-dismiss="modal"
          href={() => false}
          onClick={props.onHide}
        >
          <span className="btn-icon-left">
            <i className="mdi mdi-close"></i>
          </span>{" "}
          Đóng
        </a>
      </Modal.Footer>
    </Modal>
  );
};
